//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import HrFamilyAssignmentCreate from '@/views/HumanResource/HrFamilyAssignment/create'
import HrFamilyAssignmentList from '@/views/HumanResource/HrFamilyAssignment/list'
import HrFamilyAssignmentUpdate from '@/views/HumanResource/HrFamilyAssignment/update'

//
export default {
  path: 'family_assignment',
  component: ModuleLayout,
  children: [
    {
      path: '',
      name: 'family-assignment-list',
      component: HrFamilyAssignmentList,
    },
    {
      path: 'create',
      name: 'family-assignment-create',
      component: HrFamilyAssignmentCreate,
    },
    {
      path: ':id',
      name: 'family-assignment-update',
      component: HrFamilyAssignmentUpdate,
    },
  ],
  meta: {
    title: 'Topes de asignación familiar',
  },
}
